/* ============================================================
   THE ENCORE COLLECTION — shared product-page behaviour
   Loaded once per page with `defer`. Handles scroll-reveal for
   any element carrying the `.ec-reveal` class, in every Encore
   section. Section-specific behaviour lives in each section's
   own {% javascript %} block.
   ============================================================ */
(function () {
  'use strict';

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.ec-reveal:not(.ec-in)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ec-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ec-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () { initReveal(document); });

  /* Re-run when a section is re-rendered inside the Theme Customizer */
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
  });

  window.EncoreTheme = { initReveal: initReveal };
})();
